import { render, staticRenderFns } from "./tax_incentives_table.vue?vue&type=template&id=334c7866&scoped=true&"
import script from "./tax_incentives_table.vue?vue&type=script&lang=js&"
export * from "./tax_incentives_table.vue?vue&type=script&lang=js&"
import style0 from "./tax_incentives_table.vue?vue&type=style&index=0&id=334c7866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334c7866",
  null
  
)

export default component.exports